import { insertIdea } from 'common/actions/ideas';
import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { Idea } from 'common/api/endpoints/idea';
import type { View } from 'common/api/endpoints/view';
import type { Dispatch } from 'redux';

export type QueryParams = {
  groupURLName?: string;
  search?: string;
  sort?: View['sort'];
  viewURLName?: string;
};

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateIdeaQueries,
  loadQuery,
  loadMore,
  reloadQuery: reloadIdeaQuery,

  // action types
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
} = queryActionFactory<Idea, QueryParams>('ideaQueries', DataV2.queries.ideas, {
  onItemsLoaded: async (dispatch: Dispatch, items: Idea[]) => {
    await Promise.all(
      items.map((idea) => {
        return dispatch(insertIdea(idea));
      })
    );
  },
});
